<template>
  <Card>
    <template v-slot:title>Crias</template>
    <template v-slot:content>
      <BovineDataTable
        :results="bovines"
        :columns="[{ field: 'bovineRoot', hide: true }]"
      />
      <Paginator
        :rows="pageSize"
        :totalRecords="pagination.total"
        @page="onPageChange"
      ></Paginator>
    </template>
  </Card>
</template>

<script>
import { BovineApi } from '../../../services/api';
import BovineDataTable from '../../../components/BovineDataTable.vue';

export default {
  name: 'BovineCalvesCard',
  components: {
    BovineDataTable,
  },

  props: {
    id: Number,
  },

  data() {
    return {
      pageSize: 10,
      bovines: [],
      headerStyle: 'width: 100px',
      pagination: {
        total: 0,
        current: 1,
        pages: 1,
      },
    };
  },

  async created() {
    await this.fetchCalves();
  },

  methods: {
    async fetchCalves(query = {}) {
      const { results: bovines, pagination } = await BovineApi.fetch({
        order: 'desc',
        orderField: 'id',
        pageSize: this.pageSize,
        bovineRootId: this.id,
        ...query,
      });

      this.bovines = bovines;
      this.pagination = pagination;
    },

    async onPageChange({ page }) {
      await this.fetchCalves({ page: page + 1 });
    },
  },
};
</script>

<style>
</style>
